module.exports = __webpack_public_path__ + "img/kyouzai_numbers.9a8171f2.png";